<template>
  <div class="msg">
    <myhead :value="value" @next="next" @lookmore="more">{{
      detail.name|| $route.query.title || $route.meta.title
  }}</myhead>

    <div class="detail">
      <div class="height10px"></div>
      <div class="detail-content">
        <div class="flex between">
          <div></div>
          <div class="size12 C999">{{detail.reply_time}}</div>
        </div>
        <div class="item">
          <div class="pic">
            <img class="pro" v-if="detail.user_thumb == '用户已注销'" src="@/assets/img/cancelled.png" />
            <img class="pro" v-else :src="detail.user_thumb" alt="">
            <img class="hint" src="@/assets/img/ask.png" alt="">
          </div>
          <span class="ml10 b600">{{ detail.content}}</span>
        </div>
        <div class="item">
          <div class="pic">
            <img class="pro" v-if="detail.suppliers_thumb == '用户已注销'" src="@/assets/img/cancelled.png" />
            <img class="pro" v-else :src="detail.suppliers_thumb" alt="">
            <img class="hint" src="@/assets/img/answer.png" alt="">
          </div>
          <span class="ml10">{{detail.remarks}}</span>
        </div>
      </div>
    </div>

    <div class="recommend" v-if="list.length !== 0">
      <div class="title">相关咨询</div>
      <div class="recommend-content" v-for="item,index in list" :key="index">
        <div class="mb15 recommend-item">
          <div class="flex between">
            <div></div>
            <div class="size12 C999">{{item.reply_time}}</div>
          </div>
          <div class="item">
            <div class="pic">
              <img class="pro" v-if="item.user_thumb == '用户已注销'" src="@/assets/img/cancelled.png" />
              <img class="pro" v-else :src="item.user_thumb" alt="">
              <img class="hint" src="@/assets/img/ask.png" alt="">
            </div>
            <span class="ml10 b600">{{ item.content}}</span>
          </div>
          <div class="item">
            <div class="pic">
              <img class="pro" v-if="item.suppliers_thumb == '用户已注销'" src="@/assets/img/cancelled.png" />
              <img class="pro" v-else :src="item.suppliers_thumb" alt="">
              <img class="hint" src="@/assets/img/answer.png" alt="">
            </div>
            <span class="ml10">{{item.remarks}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script setup>
import { ref } from "vue";
import { nextFn } from "@/utils/type.js";
import ajax from "@/utils/request.js";
import { useRoute } from "vue-router";

const route = useRoute();
const { query } = route;
//右箭头
const next = () => {
  nextFn();
};

const detail = ref({});
const list = ref([]);
const data = {
  id: query.id,
  type: query.type
};
if (data.type == 1) {
  ajax.post("products/getmessage", data).then((res) => {
    detail.value = res.data;
    ajax.post("products/getmessages", { goods_id: res.data.goods_id, id: res.data.id }).then((res) => {
      list.value = res.data
    });
  });
}
if (data.type == 3) {
  ajax.post("users/getmessageinfo", data).then((res) => {
    detail.value = res.data;
  });
}
</script>
<style lang="scss" scoped>
.msg{
  width: 100%;
  height: 100%;
  background-color: #edefef;
}
.pic{
  position: relative;
  width: 40px;
  height: 40px;
  .pro{
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .hint{
    position: absolute;
    bottom: 0;
    right: 0;
    width: 25px;
    height: 25px;
    opacity: 0.8;
  }
  /* border: 1px solid #000; */

}
.item{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.detail {
  width: 100%;
  margin-top: 15px;
  z-index: 10;
}
.detail__tle {
  font-size: 16px;
  color: #666666;
  font-weight: 700;
  margin-top: 16px;
  margin-bottom: 12px;

}
.detail__time {
  font-size: 12px;
  color: #999999;
  margin-bottom: 30px;

}
.detail-content{
  margin: 0 10px;
  padding: 5px;
  background-color: #fff;
  border-radius: 10px;
  
}
.recommend{
  // background-color: #fff;
  // margin: 0 10px;
  border-radius: 10px;
  .title{
    margin: 0 10px;
    margin-top: 10px;
    padding: 10px 0;
    padding-left: 10px;
    font-size: 16px ;
    font-weight: bold;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #fff;
    // padding: 10px;
  }
  .recommend-content{
    // padding: 5px;
    border-radius: 10px;
    margin: 0 10px;
    margin-bottom: 10px;
    .recommend-item{
      padding: 5px;
      border-radius: 10px;
      background-color: #fff;
      &:first-child{
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }
}
</style>
